import { useEffect } from 'react'
import { Flex, Text } from '@jisr-hr/design-system'
import { toast } from 'react-toastify'
// import QS from 'qs'
// import { useLocation } from 'react-router-dom'
import { useDispatch } from 'utils/hooks'
import { toggleNotificationsPanel } from 'redux/appNotifications/actionCreators'
import FAICon from 'components/fontawesome/FAICon'
import { useHistory } from 'react-router-dom'

import styles from '../styles.module.css'

const CustomToast = ({ message }: { message: string }): JSX.Element => {
  return (
    <Flex style={{ gap: 16 }}>
      <Flex
        itemsCenter
        justifyCenter
        className={styles.imgContainer}
      >
        <FAICon
          icon={['far', 'bell']}
          size="xl"
        />
      </Flex>
      <div style={{ flex: 1 }}>
        <Text typography="paragraph16">{message}</Text>
        {/* <Text
          typography="paragraph16"
          color="var(--color-natural-gray-default-new)"
        >
          1 hour ago
        </Text> */}
      </div>
    </Flex>
  )
}

export default function Notifications(): null {
  const dispatch = useDispatch()
  const history = useHistory()

  const onClickNotification = (): void => {
    history.replace('/scheduler')
  }

  const togglePanel = (): void => {
    dispatch(toggleNotificationsPanel(true))
  }

  useEffect(() => {
    navigator.serviceWorker?.addEventListener('message', (event) => {
      const { data, notification } = event?.data
      if (data?.push_type !== '10' && notification?.body) {
        toast(<CustomToast message={notification?.body} />, {
          onClick: () =>
            data?.category_type === 'bulk_import' ? onClickNotification() : togglePanel(),
          autoClose: false,
        })
      }
    })
  }, [])

  // useEffect(() => {
  //   if (open_notifications === 'true') {
  //     dispatch(toggleNotificationsPanel(true))
  //   }
  // }, [open_notifications])

  return null
}
